function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("path", {
  d: "M115.044,79.232v2.119h1.563l-1.549-.208c-.005.039-.011.077-.025.162s-.019.121-.027.173a3.869,3.869,0,0,0-.047.582,22.852,22.852,0,0,1-.567,4.735,23.814,23.814,0,0,1-6.475,12.088,31.67,31.67,0,0,1-8.406,5.952,54.852,54.852,0,0,1-12,4.228A93.42,93.42,0,0,1,77.1,110.882c-3.012.368-5.782.61-8.434.726-1.631.075-2.935.114-5.879.189-1.292.033-1.869.048-2.589.069a3.518,3.518,0,0,0-.454.046l-.1.014.168,1.554v-1.563H58.361v1.563l.117-1.559-.19-.018c-.235-.024-.348-.034-.51-.038-3.86-.039-7.373-.169-10.728-.411a111.209,111.209,0,0,1-12.83-1.634,65.719,65.719,0,0,1-11.69-3.288,37.664,37.664,0,0,1-9.645-5.365A24.061,24.061,0,0,1,4.368,88.782,28.361,28.361,0,0,1,3.3,82.72c-.017-.252-.046-.5-.091-.807-.013-.086-.022-.15-.046-.306-.028-.186-.041-.272-.055-.373l-1.548.215H3.126c0-1.111,0-1.111,0-2.218H1.563l1.544.246c.009-.059.02-.114.045-.245a5.2,5.2,0,0,0,.116-.821,51.684,51.684,0,0,1,1.6-10.058A86.512,86.512,0,0,1,9.52,55.1,156.452,156.452,0,0,1,19.073,36.83,129.467,129.467,0,0,1,30.481,20.517a68.715,68.715,0,0,1,9.4-9.456,39.216,39.216,0,0,1,8.9-5.587,26.176,26.176,0,0,1,8.149-2.189c.234-.022.474-.048.773-.082l.373-.044.366-.043-.179-1.553V3.126H60V1.563L59.724,3.1l.084.018.083.018a3,3,0,0,0,.424.063c.19.022.4.043.815.081l.037,0c.8.074,1.146.112,1.562.176a27.549,27.549,0,0,1,8.991,3.087,46.32,46.32,0,0,1,10.047,7.47,81.2,81.2,0,0,1,9.114,10.373,161.357,161.357,0,0,1,16.474,27.59A89.357,89.357,0,0,1,113.3,67.985a45.168,45.168,0,0,1,1.66,10.708,3.636,3.636,0,0,0,.073.629c.014.076.019.1.022.13l1.547-.221Zm3.126,0v-.111l-.016-.11c-.011-.077-.02-.129-.04-.243s-.024-.142-.024-.144A48.111,48.111,0,0,0,116.33,67.2a92.43,92.43,0,0,0-6.151-16.562A164.466,164.466,0,0,0,93.386,22.519a84.293,84.293,0,0,0-9.464-10.768A49.384,49.384,0,0,0,73.2,3.791,30.644,30.644,0,0,0,63.2.37c-.492-.076-.881-.118-1.742-.2l-.037,0c-.395-.037-.6-.056-.821-.081a.4.4,0,0,1-.061-.009L60.479.066c-.088-.019-.135-.029-.2-.041L60.141,0H58.175l-.089.01-.375.044L57.345.1c-.279.032-.5.056-.707.076a29.292,29.292,0,0,0-9.118,2.442,42.3,42.3,0,0,0-9.607,6.021,71.777,71.777,0,0,0-9.832,9.879,132.532,132.532,0,0,0-11.686,16.7,159.526,159.526,0,0,0-9.74,18.634A89.59,89.59,0,0,0,1.843,67.581a54.782,54.782,0,0,0-1.7,10.666,2.915,2.915,0,0,1-.062.384c-.033.168-.048.246-.065.354L0,79.108v2.449l.015.107c.017.12.031.215.061.415.023.148.032.207.043.284.034.237.055.412.066.573a31.478,31.478,0,0,0,1.183,6.726,27.181,27.181,0,0,0,9.582,13.964,40.743,40.743,0,0,0,10.434,5.817,68.8,68.8,0,0,0,12.244,3.448,114.31,114.31,0,0,0,13.193,1.682c3.426.247,7,.379,10.9.419.031,0,.091.006.245.022.131.014.193.019.277.026l.117,0h1.533l.084-.009c.073-.008.122-.015.224-.03l.1-.014c.7-.021,1.279-.036,2.566-.068,2.964-.075,4.282-.115,5.939-.191,2.736-.119,5.586-.369,8.672-.746a96.52,96.52,0,0,0,10.76-1.88,57.923,57.923,0,0,0,12.681-4.476,34.766,34.766,0,0,0,9.223-6.545,26.937,26.937,0,0,0,7.311-13.636,25.89,25.89,0,0,0,.636-5.381,1.038,1.038,0,0,1,.014-.133c0-.032.009-.058.02-.13.018-.113.027-.169.037-.244l.014-.1V79.232Z",
  fill: "none"
})), React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.007,
  y1: -0.007,
  x2: 0.993,
  y2: 1.007,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0
}), React.createElement("stop", {
  offset: 0,
  stopColor: "#64d7e0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#d3e5e6"
}), React.createElement("stop", {
  offset: 1
})), React.createElement("clipPath", {
  id: "clip-path-2"
}, React.createElement("path", {
  d: "M108.532,73.273v2a5.073,5.073,0,0,0-.08.67,23.149,23.149,0,0,1-.568,4.776,23.938,23.938,0,0,1-6.5,12.132,31.42,31.42,0,0,1-8.316,5.9,53.457,53.457,0,0,1-11.642,4.106,89.8,89.8,0,0,1-9.989,1.745c-2.683.328-5.376.577-8.07.694-2.673.122-5.341.166-8.009.244-.136,0-.271.034-.407.049H53.583c-.2-.015-.392-.044-.588-.049-3.4-.034-6.8-.147-10.19-.391a106.741,106.741,0,0,1-12.275-1.564,63.714,63.714,0,0,1-11.29-3.177,37.129,37.129,0,0,1-9.471-5.274A24.179,24.179,0,0,1,1.231,82.7a28.237,28.237,0,0,1-1.06-6.032C.141,76.23.06,75.8,0,75.365V73.273a8.1,8.1,0,0,0,.136-.851,50.338,50.338,0,0,1,1.558-9.776A83.339,83.339,0,0,1,6.155,49.917a149.648,149.648,0,0,1,9.1-17.407A124.313,124.313,0,0,1,26.148,16.937a66.6,66.6,0,0,1,9.074-9.121,38.567,38.567,0,0,1,8.728-5.475A26.191,26.191,0,0,1,52.1.156c.467-.044.93-.1,1.4-.156H55.13a3.86,3.86,0,0,0,.4.073c.8.088,1.6.137,2.4.259A27.5,27.5,0,0,1,66.883,3.4a45.359,45.359,0,0,1,9.8,7.278,78.218,78.218,0,0,1,8.763,9.972,153.826,153.826,0,0,1,15.692,26.278,86.07,86.07,0,0,1,5.708,15.363,44.553,44.553,0,0,1,1.613,10.446A4.709,4.709,0,0,0,108.532,73.273Z",
  fill: "none",
  clipRule: "evenodd"
})), React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.007,
  y1: -0.007,
  x2: 0.993,
  y2: 1.007,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0
}), React.createElement("stop", {
  offset: 0,
  stopColor: "#d3e5e6"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#64d7e0"
}), React.createElement("stop", {
  offset: 1
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-578.92 -13.636)"
}, React.createElement("g", {
  transform: "matrix(0.259, 0.966, -0.966, 0.259, 702.177, 20.217)"
}, React.createElement("g", {
  transform: "translate(0 0)",
  clipPath: "url(#clip-path)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  d: "M0,0H118.17V115.044H0Z",
  transform: "translate(0)",
  fill: "url(#linear-gradient)"
})))), React.createElement("g", {
  transform: "translate(578.92 67.902) rotate(-30)"
}, React.createElement("g", {
  transform: "translate(0 0)",
  clipPath: "url(#clip-path-2)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  d: "M0,0H108.532V105.583H0Z",
  fill: "url(#linear-gradient-2)"
})))), React.createElement("g", {
  transform: "translate(627.329 61.529)"
}, React.createElement("g", {
  id: "Ellipse_3",
  fill: "none",
  stroke: "#ecf4f8",
  strokeWidth: 4
}, React.createElement("circle", {
  cx: 25.054,
  cy: 25.054,
  r: 25.054,
  stroke: "none"
}), React.createElement("circle", {
  cx: 25.054,
  cy: 25.054,
  r: 23.054,
  fill: "none"
})), React.createElement("g", {
  transform: "translate(10.629 9.111)"
}, React.createElement("g", {
  transform: "translate(0 21.567)"
}, React.createElement("path", {
  d: "M28.757,10.784V7.189A7.189,7.189,0,0,0,21.567,0H7.189A7.189,7.189,0,0,0,0,7.189v3.595",
  fill: "none",
  stroke: "#ecf4f8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
})), React.createElement("g", {
  transform: "translate(7.189)"
}, React.createElement("path", {
  d: "M7.189,14.378A7.189,7.189,0,1,0,0,7.189,7.189,7.189,0,0,0,7.189,14.378Z",
  fill: "none",
  stroke: "#ecf4f8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
})))));

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 153.841,
    viewBox: "0 0 153.841 150.5",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.db8157bc.svg";
export { ForwardRef as ReactComponent };